/**
 * U.S. State to Region Mapping
 * Based on the standard U.S. Map Regions classification
 */

export const US_REGIONS = {
  PACIFIC: 'Pacific',
  ROCKY_MOUNTAINS: 'Rocky Mountains',
  SOUTHWEST: 'Southwest',
  MIDWEST: 'Midwest',
  SOUTHEAST: 'Southeast',
  NORTHEAST: 'Northeast',
  NONCONTIGUOUS: 'Noncontiguous'
};

// State to Region Mapping
export const STATE_REGION_MAP = {
  // Pacific Region (蓝色)
  'Washington': US_REGIONS.PACIFIC,
  'WA': US_REGIONS.PACIFIC,
  'Oregon': US_REGIONS.PACIFIC,
  'OR': US_REGIONS.PACIFIC,
  'California': US_REGIONS.PACIFIC,
  'CA': US_REGIONS.PACIFIC,
  
  // Rocky Mountains Region (橙色)
  'Montana': US_REGIONS.ROCKY_MOUNTAINS,
  'MT': US_REGIONS.ROCKY_MOUNTAINS,
  'Idaho': US_REGIONS.ROCKY_MOUNTAINS,
  'ID': US_REGIONS.ROCKY_MOUNTAINS,
  'Wyoming': US_REGIONS.ROCKY_MOUNTAINS,
  'WY': US_REGIONS.ROCKY_MOUNTAINS,
  'Nevada': US_REGIONS.ROCKY_MOUNTAINS,
  'NV': US_REGIONS.ROCKY_MOUNTAINS,
  'Utah': US_REGIONS.ROCKY_MOUNTAINS,
  'UT': US_REGIONS.ROCKY_MOUNTAINS,
  'Colorado': US_REGIONS.ROCKY_MOUNTAINS,
  'CO': US_REGIONS.ROCKY_MOUNTAINS,
  
  // Southwest Region (粉红色)
  'Arizona': US_REGIONS.SOUTHWEST,
  'AZ': US_REGIONS.SOUTHWEST,
  'New Mexico': US_REGIONS.SOUTHWEST,
  'NM': US_REGIONS.SOUTHWEST,
  'Texas': US_REGIONS.SOUTHWEST,
  'TX': US_REGIONS.SOUTHWEST,
  'Oklahoma': US_REGIONS.SOUTHWEST,
  'OK': US_REGIONS.SOUTHWEST,
  
  // Midwest Region (棕色/tan色)
  'North Dakota': US_REGIONS.MIDWEST,
  'ND': US_REGIONS.MIDWEST,
  'South Dakota': US_REGIONS.MIDWEST,
  'SD': US_REGIONS.MIDWEST,
  'Nebraska': US_REGIONS.MIDWEST,
  'NE': US_REGIONS.MIDWEST,
  'Kansas': US_REGIONS.MIDWEST,
  'KS': US_REGIONS.MIDWEST,
  'Minnesota': US_REGIONS.MIDWEST,
  'MN': US_REGIONS.MIDWEST,
  'Iowa': US_REGIONS.MIDWEST,
  'IA': US_REGIONS.MIDWEST,
  'Missouri': US_REGIONS.MIDWEST,
  'MO': US_REGIONS.MIDWEST,
  'Wisconsin': US_REGIONS.MIDWEST,
  'WI': US_REGIONS.MIDWEST,
  'Illinois': US_REGIONS.MIDWEST,
  'IL': US_REGIONS.MIDWEST,
  'Indiana': US_REGIONS.MIDWEST,
  'IN': US_REGIONS.MIDWEST,
  'Michigan': US_REGIONS.MIDWEST,
  'MI': US_REGIONS.MIDWEST,
  'Ohio': US_REGIONS.MIDWEST,
  'OH': US_REGIONS.MIDWEST,
  
  // Southeast Region (黄色)
  'Arkansas': US_REGIONS.SOUTHEAST,
  'AR': US_REGIONS.SOUTHEAST,
  'Louisiana': US_REGIONS.SOUTHEAST,
  'LA': US_REGIONS.SOUTHEAST,
  'Mississippi': US_REGIONS.SOUTHEAST,
  'MS': US_REGIONS.SOUTHEAST,
  'Alabama': US_REGIONS.SOUTHEAST,
  'AL': US_REGIONS.SOUTHEAST,
  'Tennessee': US_REGIONS.SOUTHEAST,
  'TN': US_REGIONS.SOUTHEAST,
  'Kentucky': US_REGIONS.SOUTHEAST,
  'KY': US_REGIONS.SOUTHEAST,
  'Georgia': US_REGIONS.SOUTHEAST,
  'GA': US_REGIONS.SOUTHEAST,
  'Florida': US_REGIONS.SOUTHEAST,
  'FL': US_REGIONS.SOUTHEAST,
  'South Carolina': US_REGIONS.SOUTHEAST,
  'SC': US_REGIONS.SOUTHEAST,
  'North Carolina': US_REGIONS.SOUTHEAST,
  'NC': US_REGIONS.SOUTHEAST,
  'Virginia': US_REGIONS.SOUTHEAST,
  'VA': US_REGIONS.SOUTHEAST,
  
  // Northeast Region (绿色)
  'West Virginia': US_REGIONS.NORTHEAST,
  'WV': US_REGIONS.NORTHEAST,
  'Maryland': US_REGIONS.NORTHEAST,
  'MD': US_REGIONS.NORTHEAST,
  'Delaware': US_REGIONS.NORTHEAST,
  'DE': US_REGIONS.NORTHEAST,
  'Pennsylvania': US_REGIONS.NORTHEAST,
  'PA': US_REGIONS.NORTHEAST,
  'New Jersey': US_REGIONS.NORTHEAST,
  'NJ': US_REGIONS.NORTHEAST,
  'New York': US_REGIONS.NORTHEAST,
  'NY': US_REGIONS.NORTHEAST,
  'Connecticut': US_REGIONS.NORTHEAST,
  'CT': US_REGIONS.NORTHEAST,
  'Rhode Island': US_REGIONS.NORTHEAST,
  'RI': US_REGIONS.NORTHEAST,
  'Massachusetts': US_REGIONS.NORTHEAST,
  'MA': US_REGIONS.NORTHEAST,
  'Vermont': US_REGIONS.NORTHEAST,
  'VT': US_REGIONS.NORTHEAST,
  'New Hampshire': US_REGIONS.NORTHEAST,
  'NH': US_REGIONS.NORTHEAST,
  'Maine': US_REGIONS.NORTHEAST,
  'ME': US_REGIONS.NORTHEAST,
  
  // Noncontiguous (灰色)
  'Alaska': US_REGIONS.NONCONTIGUOUS,
  'AK': US_REGIONS.NONCONTIGUOUS,
  'Hawaii': US_REGIONS.NONCONTIGUOUS,
  'HI': US_REGIONS.NONCONTIGUOUS,
};

/**
 * Get region name by state name or abbreviation
 * @param {string} state - State name or abbreviation
 * @returns {string|null} - Region name or null if not found
 */
export const getRegionByState = (state) => {
  console.log(">>> getRegionByState called with:", state);
  
  if (!state) {
    console.log(">>> State is null or undefined");
    return null;
  }
  
  // Trim and handle case insensitivity
  const normalizedState = state.trim();
  console.log(">>> Normalized state:", normalizedState);
  
  // Try exact match first
  if (STATE_REGION_MAP[normalizedState]) {
    console.log(">>> Exact match found:", STATE_REGION_MAP[normalizedState]);
    return STATE_REGION_MAP[normalizedState];
  }
  
  console.log(">>> No exact match, trying case-insensitive search");
  
  // Try case-insensitive match
  const stateKey = Object.keys(STATE_REGION_MAP).find(
    key => key.toLowerCase() === normalizedState.toLowerCase()
  );
  
  if (stateKey) {
    console.log(">>> Case-insensitive match found. Key:", stateKey, "Region:", STATE_REGION_MAP[stateKey]);
    return STATE_REGION_MAP[stateKey];
  }
  
  console.log(">>> No match found in STATE_REGION_MAP");
  return null;
};

/**
 * Extract state from Mapbox geocoding result
 * @param {object} result - Mapbox geocoding result
 * @returns {string|null} - State name or abbreviation
 */
export const extractStateFromGeocodingResult = (result) => {
  console.log(">>> extractStateFromGeocodingResult called");
  console.log(">>> Input result:", result);
  
  if (!result) {
    console.log(">>> Result is null or undefined");
    return null;
  }
  
  // Strategy 1: Check if the result itself is a US region/state
  console.log(">>> Checking if result itself is a US region");
  console.log(">>> result.id:", result.id);
  console.log(">>> result.place_type:", result.place_type);
  console.log(">>> result.properties.short_code:", result.properties?.short_code);
  
  if (result.id && result.id.startsWith('region.')) {
    console.log(">>> Result is a region type");
    const shortCode = result.properties?.short_code;
    
    if (shortCode) {
      console.log(">>> short_code found:", shortCode);
      const parts = shortCode.split('-');
      console.log(">>> Split parts:", parts);
      
      if (parts.length === 2 && parts[0] === 'US') {
        console.log(">>> This is a US state! Returning:", parts[1]);
        return parts[1];
      } else {
        console.log(">>> Not a US state (prefix is:", parts[0] + ")");
      }
    }
  }
  
  // Strategy 2: Check result.context for region
  if (!result.context) {
    console.log(">>> Result.context is missing, cannot proceed with context search");
    return null;
  }
  
  console.log(">>> Searching in result.context:", result.context);
  
  // Find the region context item (state level)
  const stateContext = result.context.find(
    item => item.id && item.id.startsWith('region.')
  );
  
  console.log(">>> Found stateContext in context:", stateContext);
  
  if (stateContext) {
    // Extract state abbreviation from short_code (e.g., "US-CA" -> "CA")
    if (stateContext.short_code) {
      console.log(">>> stateContext.short_code:", stateContext.short_code);
      const parts = stateContext.short_code.split('-');
      console.log(">>> Split parts:", parts);
      
      if (parts.length === 2 && parts[0] === 'US') {
        console.log(">>> Returning state abbreviation from context:", parts[1]);
        return parts[1];
      } else {
        console.log(">>> Not a US state in context (prefix is:", parts[0] + ")");
      }
    }
    
    // Fallback to text (full state name) - only if it looks like a US state
    console.log(">>> Checking text fallback:", stateContext.text);
    // Don't use text fallback for non-US locations
  }
  
  console.log(">>> No US state found, returning null");
  return null;
};

/**
 * Get region from Mapbox geocoding result
 * @param {object} result - Mapbox geocoding result object
 * @returns {string|null} - Region name or null
 */
export const getRegionFromGeocodingResult = (result) => {
  console.log(">>> getRegionFromGeocodingResult called");
  const state = extractStateFromGeocodingResult(result);
  console.log(">>> State from extraction:", state);
  const region = getRegionByState(state);
  console.log(">>> Final region:", region);
  return region;
};

/**
 * Extract city from Mapbox geocoding result
 * @param {object} result - Mapbox geocoding result
 * @returns {string|null} - City name or null
 */
export const extractCityFromGeocodingResult = (result) => {
  console.log(">>> extractCityFromGeocodingResult called");
  console.log(">>> Input result:", result);
  
  if (!result) {
    console.log(">>> Result is null or undefined");
    return null;
  }
  
  // Strategy 1: Check if the result itself is a place (city)
  if (result.id && result.id.startsWith('place.')) {
    console.log(">>> Result is a place type, using result.text:", result.text);
    return result.text || null;
  }
  
  // Strategy 2: Check result.context for place
  if (!result.context) {
    console.log(">>> Result.context is missing");
    return null;
  }
  
  console.log(">>> Searching in result.context for place:", result.context);
  
  // Find the place context item (city level)
  const cityContext = result.context.find(
    item => item.id && item.id.startsWith('place.')
  );
  
  console.log(">>> Found cityContext:", cityContext);
  
  if (cityContext && cityContext.text) {
    console.log(">>> Returning city:", cityContext.text);
    return cityContext.text;
  }
  
  console.log(">>> No city found, returning null");
  return null;
};

/**
 * Extract country from Mapbox geocoding result
 * @param {object} result - Mapbox geocoding result
 * @returns {string|null} - Country name or null
 */
export const extractCountryFromGeocodingResult = (result) => {
  console.log(">>> extractCountryFromGeocodingResult called");
  console.log(">>> Input result:", result);
  
  if (!result) {
    console.log(">>> Result is null or undefined");
    return null;
  }
  
  // Strategy 1: Check if the result itself is a country
  if (result.id && result.id.startsWith('country.')) {
    console.log(">>> Result is a country type, using result.text:", result.text);
    return result.text || null;
  }
  
  // Strategy 2: Check result.context for country
  if (!result.context) {
    console.log(">>> Result.context is missing");
    return null;
  }
  
  console.log(">>> Searching in result.context for country:", result.context);
  
  // Find the country context item
  const countryContext = result.context.find(
    item => item.id && item.id.startsWith('country.')
  );
  
  console.log(">>> Found countryContext:", countryContext);
  
  if (countryContext && countryContext.text) {
    console.log(">>> Returning country:", countryContext.text);
    return countryContext.text;
  }
  
  console.log(">>> No country found, returning null");
  return null;
};

/**
 * Extract full state name from Mapbox geocoding result (not abbreviation)
 * @param {object} result - Mapbox geocoding result
 * @returns {string|null} - Full state name or null
 */
export const extractStateNameFromGeocodingResult = (result) => {
  console.log(">>> extractStateNameFromGeocodingResult called");
  
  if (!result) {
    console.log(">>> Result is null or undefined");
    return null;
  }
  
  // Check if the result itself is a US region/state
  if (result.id && result.id.startsWith('region.')) {
    console.log(">>> Result is a region type, using result.text:", result.text);
    return result.text || null;
  }
  
  // Check result.context for region
  if (!result.context) {
    console.log(">>> Result.context is missing");
    return null;
  }
  
  // Find the region context item (state level)
  const stateContext = result.context.find(
    item => item.id && item.id.startsWith('region.')
  );
  
  console.log(">>> Found stateContext:", stateContext);
  
  if (stateContext && stateContext.text) {
    console.log(">>> Returning state name:", stateContext.text);
    return stateContext.text;
  }
  
  console.log(">>> No state found, returning null");
  return null;
};

// Export all region options for Select component
export const REGION_OPTIONS = Object.values(US_REGIONS).filter(
  (value, index, self) => self.indexOf(value) === index
).map(region => ({
  label: region,
  value: region
}));

